import React from "react";
import { Typography, Box, makeStyles } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";

const useStyles = makeStyles(theme => ({
  root: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));

export const StepTitle = props => {
  const { title } = props;
  const { t } = useTranslation("common");

  return <Typography variant="h6">{t(`setting.${title}`)}</Typography>;
};

export const SettingTitle = props => {
  const { title, action, actionsHideGroupOrTagSelection } = props;
  const { t } = useTranslation("devicesGroups");

  return (
    <Typography
      variant="body1"
      color={
        actionsHideGroupOrTagSelection.includes(action)
          ? "textSecondary"
          : "primary"
      }
    >
      {t(`setting.${title}`)}
    </Typography>
  );
};

export const SettingText = props => {
  const { text } = props;
  const { t } = useTranslation("devicesGroups");

  return (
    <Typography variant="body1" color="primary">
      {t(`setting.${text}`)}
    </Typography>
  );
};

export const MissingSelectedErrorText = props => {
  const { text } = props;
  const { t } = useTranslation("common");

  return (
    <Typography variant="caption" color="error">
      {t(`setting.${text}`)}
    </Typography>
  );
};

export const FileUploadErrorText = props => {
  const { text } = props;
  const { t } = useTranslation("devicesGroups");

  return (
    <Typography variant="caption" color="error" display="block">
      {t(`setting.${text}`)}
    </Typography>
  );
};

export const NoDataText = props => {
  const { text } = props;
  const { t } = useTranslation();

  return (
    <Typography variant="body2" color="textSecondary" className="default-value">
      {text || t({ defaultMessage: "暂无数据" })}
    </Typography>
  );
};

export const DefaultMenuItem = props => {
  const { text, ifShow } = props;
  const classes = useStyles();

  if (!ifShow) return null;

  return (
    <Box>
      <Typography
        variant="body1"
        color="textSecondary"
        className={classes.root}
      >
        {text}
      </Typography>
    </Box>
  );
};

export const CaptionText = props => {
  const { text, className } = props;
  return (
    <Typography variant="caption" color="secondary" className={className}>
      {text}
    </Typography>
  );
};

export const Body2Text = props => {
  const { children, className } = props;
  return (
    <Typography variant="body2" color="secondary" className={className}>
      {children}
    </Typography>
  );
};

export const SimpleErrorText = props => {
  const { text } = props;
  return (
    <Typography variant="caption" color="error">
      {text}
    </Typography>
  );
};
